import { Stack, Typography } from '@mui/material';
import SmsIcon from '@mui/icons-material/SmsOutlined';
import EmailIcon from '@mui/icons-material/EmailOutlined';
import MarketingCreditsItem from './MarketingCreditsItem';
import useGetMarketingData from '../../../hooks/marketing/useGetMarketingData';
import { calculateCreditsUsage } from '../../../helpers/marketing';

function MarketingCredits() {
  const { data: marketingData, isLoading } = useGetMarketingData();

  const segmentUsage = marketingData?.creditsUsage;

  const { remaining, surplus } = calculateCreditsUsage({
    marketingData,
    segmentUsage,
  });

  return (
    <Stack gap={0.5}>
      <Typography variant="h4" component="p">
        Credits Remaining
      </Typography>
      <Stack direction="row" gap={1} flexWrap="wrap">
        <MarketingCreditsItem
          remaining={remaining.sms}
          total={marketingData?.monthlySmsCredits || 0}
          icon={SmsIcon}
          label="SMS"
          surplus={surplus.sms}
          isLoading={isLoading}
        />
        <MarketingCreditsItem
          remaining={remaining.email}
          total={marketingData?.monthlyEmailCredits || 0}
          icon={EmailIcon}
          label="Email"
          surplus={surplus.email}
          isLoading={isLoading}
        />
      </Stack>
    </Stack>
  );
}

export default MarketingCredits;
